import { createContext } from "react";

const AuthContext = createContext({
    wait: true,
    user: null,
    isAuthenticated: false,
    setUser: () => {},
    refreshUser: async () => {},
});

export default AuthContext;
